module.exports = __webpack_public_path__ + "img/platinum_villa_03.937ca136.jpg";